import "./scss/app.scss";

import React from "react";
import ReactDOM from "react-dom/client";

import App from "./App";
import "./i18n";

document.addEventListener('DOMContentLoaded', () => {
  const config = Object.fromEntries(new URLSearchParams(window.location.search));

  const checkinDiv = document.querySelector('div[nol-checkin]');
  const locale = checkinDiv.getAttribute('data-locale') || '';
  const url = checkinDiv.getAttribute('data-url') || '';

  ReactDOM.createRoot(checkinDiv).render(
    <React.StrictMode>
      <App config={{ locale, url, ...config }} />
    </React.StrictMode>
  );
});
